module.exports = __webpack_public_path__ + "cy.svg?bb01eb742c8b8c12c73b6ae9cd9d7732";